import { Component, Injector, OnInit } from '@angular/core';
import { RuleService } from 'tnx-admin-service/rule/services';
import {
    ComponentContextService,
    DataFormBase,
    DateTimeControlSchema,
    DropdownControlSchema,
    EventData,
    FormSchemaBase,
    SwitchControlSchema,
    TextAreaControlSchema,
    TextControlSchema,
} from 'tnx-shared';


@Component({
    selector: 'rule-form',
    templateUrl: './rule-form.component.html',
    styleUrls: ['./rule-form.component.scss'],
    providers: [ComponentContextService],
})
export class RuleFormComponent extends DataFormBase implements OnInit {
    dataSourceRuleType: any;
    constructor(
        protected _injector: Injector,
        private _ruleService: RuleService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.dataSourceRuleType = [
            { label: 'SQL_Structure -SqlDatabaseNameRequired', value: 'SqlDatabaseNameRequired' },
            { label: 'SQL_Structure -SqlTableNameRequired', value: 'SqlTableNameRequired' },
            { label: 'SQL_Structure - SqlColumnNameRequired', value: 'SqlColumnNameRequired' },
            { label: 'SQL_Data - DataRecordExistedByCode', value: 'RecordExistedByCode' },
            { label: 'SQL_Data - RecordExistedByInstanceId', value: 'RecordExistedByInstanceId' },
            { label: 'SQL_Data - RecordExistedByServiceCodeEntityEntityKey', value: 'RecordExistedByServiceCodeEntityEntityKey' },
            { label: 'SQL_Data - RecordExistedById', value: 'RecordExistedById' },
            { label: 'SQL_Data -  RecordExistByFieldValue', value: 'RecordExistByFieldValue' },
            { label: 'Etcd - ConfigKeyNameRequired', value: 'ConfigKeyNameRequired' },
            { label: 'Etcd - ConfigKeyEqualValue', value: 'ConfigKeyEqualValue' },
            { label: 'Etcd - ConfigKeyNotEqualValue', value: 'ConfigKeyNotEqualValue' },
            { label: 'Api - ApiLive', value: 'ApiLive' },
            { label: 'Api - ApiReturnCorrectValue', value: 'ApiReturnCorrectValue' },
            { label: 'Redis - RedisLive', value: 'RedisLive' }
        ];
        this.setting.baseService = this._ruleService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'code',
                label: 'Mã rule'
            }),
            new TextControlSchema({
                field: 'author',
                label: 'Người tạo rule'
            }),
            new TextControlSchema({
                field: 'title',
                label: 'Tên rule'
            }),
            new TextControlSchema({
                field: 'description',
                label: 'Mô tả chi tiết hơn rule'
            }),
            new DropdownControlSchema({
                dataSource: this.dataSourceRuleType,
                field: 'ruleType',
                label: 'Loại rule (sqlschema,etcd,environment,sqldata....)'
            }),
            new TextControlSchema({
                field: 'ruleParams',
                label: 'Tham số để có thể check rule'
            }),
            new SwitchControlSchema({
                field: 'rulePassed',
                label: 'Rule đang thỏa mãn hay không thỏa mãn'
            }),
            new DateTimeControlSchema({
                field: 'passedAt',
                label: 'Thời gian rule chuyển sang trạng thái thỏa mãn'
            }),
            new DateTimeControlSchema({
                field: 'lastCheckedAt',
                label: 'Lần kiểm tra cuối'
            }),
            new DateTimeControlSchema({
                field: 'lastFailedAt',
                label: 'Thời điểm gần nhất rule chuyển sang không thỏa mãn'
            }),
            new DateTimeControlSchema({
                field: 'nextCheckedAt',
                label: 'Lần kiểm tra rule tiếp theo'
            }),
            new TextControlSchema({
                field: 'intervalCheckInMinutes',
                label: 'Thời gian giữa mỗi lần kiểm tra rule',
                dataFormat: 'number'
            }),
            new TextAreaControlSchema({
                field: 'exception',
                label: 'Lỗi khi check rule nếu có',
                hiddenOnView: true,
                disabled: true,
                mdWidth: 12,
                rows: 50

            })
        ];
    }

    async getDetailCustom() {
        return this._ruleService.getDetailCustom(this.model.data.id, this._commonService.guidEmpty());
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }


    onBeforeSave() {
        // trước khi lưu
    }
}

